import { nudge, toast } from '../service/NotificationService';

import { NotificationBanner } from './jdsnotificationbanner/generated';
import { NotificationContainer } from './notifications/container/NotificationContainer';

export * from './jdsmodaldesktop';
export * from './jdsdesktopbottomsheet';
export * from './generatedIndex';
export * from './custom/heading';
export { Space, ContentLayout, Grid } from './legacy';
export { registerIcons } from '@jds/react-engine';
export * from './jdsdatepickerdesktop';

export * from './jdsverticalstepper';
export { BreadcrumbItem } from './jdsbreadcrumbs';

const Notifications = {
  nudge,
  toast,
  Container: NotificationContainer,
  Banner: NotificationBanner
};

export { Notifications };

export { default as Input } from './jdsinput/LegacyInput';
